export default __webpack_public_path__ + "static/summer_containers7-738657c96c161d726fd0af721a50b532.webp";